import styled from 'styled-components'
import { device } from '../../styles/Breakpoints'
import { BackdropFadeIn, ModalScrollDown, ModalReveal } from './VSMModal.keyframes'

export const VSMModalBackdrop = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
	z-index: 10;
	animation: ${BackdropFadeIn} 0.5s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
	opacity: 1;
`

export const VSMModalScroll = styled.div`
	/* height: 100%; */
	background-color: #fff;
	border-radius: 5px;
	position: relative;
	padding: 35px 45px;

	animation: ${ModalScrollDown} 0.9s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
`

export const VSMModalScrollContent = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;

	@media ${device.xs} {
		flex-direction: row;
	}

	p {
		margin: 0;
		padding-top: 20px;

		@media ${device.xs} {
			padding-left: 25px;
			padding-top: 0;
		}
	}
`

export const VSMCTA = styled.div`
	a {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		padding: 10px;
		margin-top: 30px;
		text-align: center;
		color: #fff;
		font-family: 'Source Sans Pro', sans-serif;
		font-size: 20px;
		text-decoration: none;
	}
`

export const CloseModalButton = styled.button`
	position: absolute;
	top: -20px;
	right: 10px;
	width: 40px;
	height: 40px;
	border-radius: 50%;
	padding: 10px;
	display: block;
	margin: 0;
	z-index: 10;
	background-color: #fff;
	box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);

	@media ${device.sm} {
		top: 10px;
		right: -20px;
	}

	&:hover {
		box-shadow: none;
	}

	> div {
		height: 2px;
		background: #000;
		width: 100%;
		transform-origin: 42% 45%;

		:first-child {
			transform: rotate(45deg);
		}

		:last-child {
			transform: rotate(-45deg);
		}
	}
`

export const TopBar = styled.div`
	// position: sticky;
	// z-index: 1;
	padding-left: 3em;
	width: 100%;
	color: #fff;
`

export const ModalTab = styled.span`
	display: flex;
	position: relative;
	justify-content: center;
	align-items: center;
	width: 15em;
	padding: 8px 10px 5px;
	color: #fff;
	text-transform: uppercase;
	font-size: 13px;
	letter-spacing: 0.3em;
	font-weight: 600;
	font-family: 'Source Sans Pro', sans-serif;

	&:before {
		content: '';
		position: absolute;
		top: 0;
		right: 0;
		bottom: 7px;
		left: 0;
		z-index: -1;
		border-bottom: none;
		border-radius: 0.4em 0.4em 0 0;
		transform: scale(0.8, 1.6) perspective(0.5em) rotateX(5deg);
		transform-origin: top;
	}
`

export const VSMModalWrapper = styled.div`
	width: 100%;
	max-width: 100%;
	position: fixed;
	left: 50%;
	top: 50%;
	z-index: 10;
	transform: translate(-50%, -50%);
	animation: ${ModalReveal} 1s ease;

	@media ${device.sm} {
		width: 85vw;
		max-width: 700px;
	}

	&.ideate {
		${ModalTab} {
			color: #000;

			&:before {
				background: #ffc322;
			}
		}

		${VSMCTA} {
			background: #ffc322;
			&:hover {
				background: #ffd35c;
			}

			a {
				color: #000;
			}
		}

		${CloseModalButton} {
			border: 2px solid #ffc322;

			&:hover {
				background-color: #fff9e9;
			}
		}
	}

	&.create {
		${ModalTab} {
			&:before {
				background: #a049ca;
			}
		}

		${VSMCTA} {
			background: #a049ca;
			&:hover {
				background: #b471d6;
			}
		}

		${CloseModalButton} {
			border: 2px solid #a049ca;

			&:hover {
				background-color: #f0e6f5;
			}
		}
	}

	&.release {
		${ModalTab} {
			&:before {
				background: #eb4a10;
			}
		}

		${VSMCTA} {
			background: #eb4a10;
			&:hover {
				background: #f27040;
			}
		}

		${CloseModalButton} {
			border: 2px solid #eb4a10;

			&:hover {
				background-color: #fff2ed;
			}
		}
	}

	&.operate {
		${ModalTab} {
			&:before {
				background: #00abb3;
			}
		}

		${VSMCTA} {
			background: #00abb3;
			&:hover {
				background: #00d5e0;
			}
		}

		${CloseModalButton} {
			border: 2px solid #00abb3;

			&:hover {
				background-color: #f1fefe;
			}
		}
	}

	&.measure {
		${ModalTab} {
			&:before {
				background: #608c00;
			}
		}

		${VSMCTA} {
			background: #608c00;
			&:hover {
				background: #7db800;
			}
		}

		${CloseModalButton} {
			border: 2px solid #608c00;

			&:hover {
				background-color: #f9ffeb;
			}
		}
	}

	&.optimize {
		${ModalTab} {
			&:before {
				background: #608c00;
			}
		}

		${VSMCTA} {
			background: #608c00;
			&:hover {
				background: #7db800;
			}
		}

		${CloseModalButton} {
			border: 2px solid #608c00;

			&:hover {
				background-color: #f9ffeb;
			}
		}
	}

	&.customer {
		${ModalTab} {
			color: #000000;

			&:before {
				background: #e6e6e2;
			}
		}

		${VSMCTA} {
			background: #e6e6e2;
			&:hover {
				background: #d9d9d3;
			}

			a {
				color: #000;
			}
		}

		${CloseModalButton} {
			border: 2px solid #e6e6e2;

			&:hover {
				background-color: #e3e3de;
			}
		}
	}
`
